<template>
  <div class="applyWriter">
    <logohead></logohead>
    <el-form ref="applyForm" :model="applyDate" :rules="rules">
      <el-form-item prop="im">
        <el-input
          v-model="applyDate.im"
          placeholder="QQ"
          class="login-form-input"
          ref="im"
        ></el-input>
      </el-form-item>
      <el-form-item prop="address">
        <el-input
          v-model="applyDate.address"
          placeholder="联系地址"
          class="login-form-input"
          ref="adress"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="usersub" @click="submitapply('applyForm')"
          >申请作家</el-button
        >
      </el-form-item>
      <el-form-item class="elseoption">
        <el-checkbox label="同意" v-model="checked"></el-checkbox>
        <router-link to="/authorAgree">《作家注册协议》</router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { applyWriter } from "apiurl/author";
export default {
  data() {
    return {
      applyDate: {
        im: "",
        address: ""
      },
      checked: true,
      rules: {
        im: [{ required: true, message: "请输入QQ", trigger: "blur" }],
        address: [
          { required: true, message: "请输入你的住址", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitapply(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.checked) {
            applyWriter({
              qq: this.applyDate.im,
              address: this.applyDate.address,
              agree: this.checked
            })
              .then(res => {
                if (res.success) {
                  this.$message({
                    message: "您已成为源石作者！",
                    type: "success"
                  });
                  this.$store.dispatch("asWriter");
                  if (this.$route.query.redirect) {
                    this.$router.push(this.$route.query.redirect);
                  } else {
                    this.$router.push("/");
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            this.$message.error("请先同意作家注册协议");
          }
        }
      });
    }
  }
};
</script>
<style>
.el-checkbox {
  margin-right: 10px;
}
</style>

<style lang="stylus" scoped>
.el-form
    width 300px
    margin 60px auto 0
    .goelse
        color #48A2DF
        a
            font-size 14px
            color #48A2DF
</style>
